import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    setDropdownOpen(false);
    navigate('/');
  };

  const navClass = `navbar ${isHome && !scrolled ? 'navbar-transparent' : 'navbar-solid'} ${scrolled ? 'navbar-scrolled' : ''}`;

  return (
    <nav className={navClass}>
      <div className="navbar-inner container">
       <Link to="/" className="navbar-logo">
       <i className="fa-solid fa-feather-pointed logo-icon"></i>
       <span className="logo-text"><i>Roamio</i></span>
       </Link>


        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/hotels" className="nav-link" onClick={() => setMenuOpen(false)}>Explore</Link>
          {user && (
            <Link to="/my-bookings" className="nav-link" onClick={() => setMenuOpen(false)}>My Trips</Link>
          )}
        </div>

        <div className="navbar-actions">
          {user ? (
            <div className="user-menu" ref={dropdownRef}>
              <button className="user-avatar-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
                <div className="avatar">
                  {user.name?.charAt(0).toUpperCase()}
                </div>
                <span className="user-name">{user.name?.split(' ')[0]}</span>
                <span className={`chevron ${dropdownOpen ? 'up' : ''}`}>▾</span>
              </button>
              {dropdownOpen && (
                <div className="dropdown">
                  <div className="dropdown-header">
                    <p className="dropdown-name">{user.name}</p>
                    <p className="dropdown-email">{user.email}</p>
                  </div>
                  <div className="dropdown-divider" />
                  <Link to="/profile" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                    <span><i class="fa-solid fa-user"></i></span> Profile
                  </Link>
                  <Link to="/my-bookings" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                    <span><i class="fa-solid fa-calendar-days"></i></span> My Bookings
                  </Link>
                  <div className="dropdown-divider" />
                  <button className="dropdown-item dropdown-logout" onClick={handleLogout}>
                    <span><i class="fa-solid fa-arrow-right-from-bracket"></i></span> Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn btn-ghost btn-sm">Sign In</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Join Free</Link>
            </div>
          )}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span /><span /><span />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
